/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import moment from "moment-timezone";

// Function to get the greeting based on the time of day
const getGreeting = (hours) => {
  if (hours >= 0 && hours < 12) {
    return "Good Morning";
  } else if (hours >= 12 && hours < 16) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
};

const Greeting = ({ name }) => {
  const [greeting, setGreeting] = useState("");

  useEffect(() => {
    const nigeriaTime = moment().tz("Africa/Lagos");
    const hours = nigeriaTime.hour();
    const newGreeting = getGreeting(hours);
    setGreeting(newGreeting);
  }, []);

  return (
    <div className="">
      <h1 className="greetingHeading leading-[1.2] font-bold">
        {greeting}!{" "}
        <span className="text-baseColor">
          {name}
          {/* Christopher{" "} */}
        </span>
        <span className="waving-hand">👋</span>
      </h1>
    </div>
  );
};

export default Greeting;
